import { trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostListener,
  inject,
  OnInit,
  Output,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/auth/components/login/services/auth.service';
import { VENDOR_STATUS } from 'src/app/auth/components/login/types/login.interface';
import {
  enterTransition,
  leaveTransition,
} from 'src/app/shared/utilities/animation';
import { ModalService } from '../../modal/services/modal.service';

const fadeIn = trigger('fadeIn', [enterTransition, leaveTransition]);

@Component({
  selector: 'app-app-aside',
  templateUrl: './app-aside.component.html',
  standalone: true,
  imports: [TranslateModule, RouterModule, CommonModule],
  providers: [ModalService],
  animations: [fadeIn],
})
export class AppAsideComponent implements OnInit {
  @Output() collapesChange: EventEmitter<unknown> = new EventEmitter();
  authService = inject(AuthService);
  modalService = inject(ModalService);
  translate = inject(TranslateService);

  collapsed = false;
  screenWidth = 0;

  STATUS = VENDOR_STATUS;

  @HostListener('window:resize', ['$event'])
  onResize(event: unknown) {
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= 1260) {
      this.collapsed = false;
      this.collapesChange.emit({
        collapsed: this.collapsed,
        screenWidth: this.screenWidth,
      });
    }
  }

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.collapesChange.emit({
      collapsed: this.collapsed,
      screenWidth: this.screenWidth,
    });
  }

  toggleCollapse(): void {
    this.collapsed = !this.collapsed;
    this.collapesChange.emit({
      collapsed: this.collapsed,
      screenWidth: this.screenWidth,
    });
  }

  logout() {
    this.modalService
      .open({
        size: 'modal-md',
        message: this.translate.instant('LOGOUT.MESSAGE'),
        submitLabel: this.translate.instant('LOGOUT.LOG_OUT'),
        cancelLabel: this.translate.instant('ACTIONS.CANCEL'),
        showHeader: false,
        alignCenter: false,
        showCancelBtn: true,
      })
      .subscribe(action => {
        if (action === 'confirm') {
          this.authService.logout();
        }
      });
  }
}
